import { render, staticRenderFns } from "./SelectCompany.vue?vue&type=template&id=2ceb9fc8&scoped=true"
import script from "./SelectCompany.vue?vue&type=script&lang=js"
export * from "./SelectCompany.vue?vue&type=script&lang=js"
import style0 from "./SelectCompany.vue?vue&type=style&index=0&id=2ceb9fc8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb9fc8",
  null
  
)

export default component.exports